import {
  MdButton,
  MdSnackbar
} from "@torre-labs/material";
import Vue from "vue";

import { Message } from "@/components/opportunity-snackbar/Message";

const messageQueue: Message[] = [];

export default Vue.extend({
  components: {
    MdButton,
    MdSnackbar
  },
  data() {
    return {
      current: new Message(""),
      isOpen: false,
      isCandidateDialogActive: false
    };
  },
  methods: {
    close(): void {
      (this.$refs.snackbar as MdSnackbar).close();
    },
    open(): void {
      (this.$refs.snackbar as MdSnackbar).open();
    },
    handleAction() {
      this.close();
      if (this.current && this.current.action) {
        this.current.action.handler();
      }
    },
    handleOpening() {
      this.isOpen = true;
    },
    handleClosing() {
      // The 'close' event at md-snackbar is triggered immediately upon the
      // duration for the snackbar is reached.
      // Wait for hide animation to finish (lasts about 400ms).
      // This is done to avoid undetermined behavior if open() is called multiple
      // times when the md-snackbar is open
      setTimeout(() => {
        this.isOpen = false;
        const next = messageQueue.shift();
        this.removeMarkAsOpen();
        if (next) {
          this.current = next;
          this.$nextTick(() => {
            // wait for props to propagate
            this.open();
            this.addMarkAsOpen();
          });
        }
      }, 500);
    },
    addMarkAsOpen(): void {
      const bodyElement = document.querySelector("body");
      if (bodyElement) {
        bodyElement.classList.add("snack-bar-open");
      }
    },
    removeMarkAsOpen(): void {
      const bodyElement = document.querySelector("body");
      if (bodyElement && bodyElement.classList.contains("snack-bar-open")) {
        bodyElement.classList.remove("snack-bar-open");
      }
    }
  },
  computed: {
    undoActionText(): boolean {
      const message = this.current;
      return !!(message.action?.text === "Undo" || message.action?.text === "Deshacer");
    }
  },
  mounted() {
    this.$root.$on("flash-message", (message: Message, candidateDialogActive: boolean) => {
      if (this.isOpen) {
        if (this.current && !this.current.same(message)) {
          messageQueue.push(message);
        }
      } else {
        this.current = message;
        this.$nextTick(() => {
          // wait for props to propagate
          this.isCandidateDialogActive = candidateDialogActive;
          this.open();
          this.addMarkAsOpen();
        });
      }
    });
  }
});
